import { axios } from "Config/ApiConfig";

import { dispatchItemToRedux } from "./CommonActions";
import ReducerTypes from "Redux/Types/ReducerTypes";
import API from "Constants/Apis";

export function getCategories() {
  return async (dispatch) => {
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.TOGGLE_LOADING,
        payload: {},
      })
    );
    try {
      const { data } = await axios({
        baseURL: API.SITE_API_V1,
        _addToken: false,
        method: "GET",
        url: "categories/tree",
      });

      if (data.status === 200) {
        dispatch(
          dispatchItemToRedux({
            type: ReducerTypes.CATEGORIES,
            payload: data.data,
          })
        );
      }
    } catch (err) {
      alert("اینترنت خودرا چک کنید");
    } finally {
      dispatch(
        dispatchItemToRedux({
          type: ReducerTypes.TOGGLE_LOADING,
          payload: {},
        })
      );
    }
  };
}

export function getBusinesses() {
  return async (dispatch, getState) => {
    const catReqParams = getState().category.requestParams;
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.TOGGLE_LOADING,
        payload: {},
      })
    );
    try {
      const params = {
        page: catReqParams.page,
      };
      if (catReqParams?.filter && catReqParams.filter.length > 0) {
        params.filter = catReqParams.filter;
      }
      let { data } = await axios({
        baseURL: API.SITE_API_V1,
        method: "GET",
        _addToken: false,
        url: `businesses/${catReqParams.section}/${catReqParams.id}`,
        params,
        // params: parmas
      });

      if (data.status === 200) {
        dispatch(
          dispatchItemToRedux({
            type: ReducerTypes.BUSINESSES_LIST,
            payload: {
              paginationData: {
                current_page: data.data.current_page,
                last_page: data.data.last_page,
              },
              businesses: data.data.data,
            },
          })
        );
      }
    } catch (err) {
      alert("اینترنت خودرا چک کنید");
    } finally {
      dispatch(
        dispatchItemToRedux({
          type: ReducerTypes.TOGGLE_LOADING,
          payload: {},
        })
      );
    }
  };
}
